import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EChartsOption } from 'echarts';
import { ISeriesPoint } from '../../models/series-point.model';
import { ChartService } from '../../services/chart.service';

/**
 * Modal que abre la columna HISTORICO de las tablas: linea de ~19 meses
 * con las etiquetas del eje X rotadas.
 */
@Component({
  selector: 'app-history-modal',
  templateUrl: './history-modal.component.html',
  styleUrl: './history-modal.component.scss',
  standalone: false,
})
export class HistoryModalComponent {

  @Output() public closed = new EventEmitter<void>();

  public options?: EChartsOption;
  private _title = '';

  @Input() public set title(value: string) { this._title = value; }
  public get title(): string { return this._title; }

  @Input() public set points(value: Array<ISeriesPoint>) {
    // El blanco es el centinela de ChartService: seriesColor() lo cambia por el
    // token --z-accent del tema vigente, que si se lee en claro y en oscuro.
    this.options = this.chartService.npsLine(value ?? [], ChartService.COLORS.text, 90);
  }

  constructor(private chartService: ChartService) {}
}
